
/**
 * ISO data
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type IsoData = ArrayBuffer | DataView | Uint8Array;
